"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nextUi = require("@tinper/next-ui");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var propTypes = {
  onOk: _propTypes["default"].func,
  onCancel: _propTypes["default"].func,
  backdrop: _propTypes["default"].bool,
  title: _propTypes["default"].string,
  okName: _propTypes["default"].string,
  cancelName: _propTypes["default"].string,
  showModal: _propTypes["default"].bool,
  close: _propTypes["default"].func
};
var defaultProps = {
  classnames: '',
  backdrop: true
};

var ModalWrap = function (_Component) {
  (0, _inherits2["default"])(ModalWrap, _Component);

  var _super = _createSuper(ModalWrap);

  function ModalWrap(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ModalWrap);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getFilterContainer", function () {
      if (_this.props.container) return _this.props.container;
      var id = _this.state.serviceCode || 'yxyweb-support-mount-model';
      var container = document.getElementById(id) || document.body;

      var _div = document.createElement('div');

      container.appendChild(_div);
      return _div;
    });
    _this.state = {
      showModal: props.showModal,
      title: props.title,
      okName: props.okName,
      cancelName: props.cancelName,
      backdrop: props.backdrop,
      maskClosable: props.maskClosable || true,
      onOk: props.onOk,
      onCancel: props.onCancel,
      serviceCode: props.serviceCode
    };
    return _this;
  }

  (0, _createClass2["default"])(ModalWrap, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var title = nextProps.title,
          okName = nextProps.okName,
          cancelName = nextProps.cancelName,
          backdrop = nextProps.backdrop,
          onOk = nextProps.onOk,
          onCancel = nextProps.onCancel,
          showModal = nextProps.showModal,
          close = nextProps.close;
      var _this$props = this.props,
          title1 = _this$props.title1,
          okName1 = _this$props.okName1,
          cancelName1 = _this$props.cancelName1,
          backdrop1 = _this$props.backdrop1,
          onOk1 = _this$props.onOk1,
          onCancel1 = _this$props.onCancel1,
          showModal1 = _this$props.showModal1,
          close1 = _this$props.close1;

      if (title !== title1 || okName !== okName1 || cancelName !== cancelName1 || backdrop !== backdrop1 || onOk !== onOk1 || onCancel !== onCancel1 || showModal !== showModal1 || close !== close1) {
        this.setState({
          title: title,
          okName: okName,
          cancelName: cancelName,
          backdrop: backdrop,
          onOk: onOk,
          onCancel: onCancel,
          showModal: showModal,
          close: close
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          title = _this$state.title,
          okName = _this$state.okName,
          cancelName = _this$state.cancelName,
          onOk = _this$state.onOk,
          onCancel = _this$state.onCancel,
          showModal = _this$state.showModal,
          maskClosable = _this$state.maskClosable;
      return _react["default"].createElement(_nextUi.Modal, {
        title: title,
        className: "ac-input-locale-modal",
        getContainer: this.getFilterContainer,
        visible: showModal,
        onOk: onOk,
        onCancel: onCancel,
        width: 600,
        draggable: true,
        fieldid: this.props.fieldid,
        maskClosable: maskClosable,
        okText: okName,
        cancelText: cancelName
      }, this.props.children);
    }
  }]);
  return ModalWrap;
}(_react.Component);

ModalWrap.propTypes = propTypes;
ModalWrap.defaultProps = defaultProps;
var _default = ModalWrap;
exports["default"] = _default;
//# sourceMappingURL=modal.js.map